import {
  selectHydraulicWallList,
} from "app/containers/HydraulicWall/redux/selector";
import hydraulicWallSaga from "app/containers/HydraulicWall/redux/saga";
import {
  hydraulicWallActions,
  reducer as hydraulicWallReducer,
  sliceKey as hydraulicWallSliceKey,
} from "app/containers/HydraulicWall/redux/slice";
import {
  selectManufacturersList,
  selectManufacturersLoading,
  selectManufacturersMeta,
} from "app/containers/Manufacturer/redux/selector";
import { manufacturerSaga } from "app/containers/Manufacturer/redux/saga";
import {
  manufacturerActions,
  reducer as manufacturerReducer,
  sliceKey as manufacturerSliceKey,
} from "app/containers/Manufacturer/redux/slice";
import {
  selectManufacturerModelsList,
  selectManufacturerModelsLoading,
  selectManufacturerModelsMeta,
} from "app/containers/ManufacturerModel/redux/selector";
import { manufacturerModelSaga } from "app/containers/ManufacturerModel/redux/saga";
import {
  manufacturerModelActions,
  reducer as manufacturerModelReducer,
  sliceKey as manufacturerModelSliceKey,
} from "app/containers/ManufacturerModel/redux/slice";
import { UIEvent, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

const toOptions = (names: string[]): [string, string][] =>
  names
    .filter((name, index) => name && names.indexOf(name) === index)
    .map((name) => [name, name]);

export const useVehicleDetails = () => {
  useInjectReducer({ key: manufacturerSliceKey, reducer: manufacturerReducer });
  useInjectSaga({ key: manufacturerSliceKey, saga: manufacturerSaga });
  useInjectReducer({
    key: manufacturerModelSliceKey,
    reducer: manufacturerModelReducer,
  });
  useInjectSaga({
    key: manufacturerModelSliceKey,
    saga: manufacturerModelSaga,
  });
  useInjectReducer({
    key: hydraulicWallSliceKey,
    reducer: hydraulicWallReducer,
  });
  useInjectSaga({ key: hydraulicWallSliceKey, saga: hydraulicWallSaga });

  const dispatch = useDispatch();
  const manufacturers = useSelector(selectManufacturersList);
  const manufacturersLoading = useSelector(selectManufacturersLoading);
  const manufacturersMeta = useSelector(selectManufacturersMeta);
  const manufacturerModels = useSelector(selectManufacturerModelsList);
  const manufacturerModelsLoading = useSelector(selectManufacturerModelsLoading);
  const manufacturerModelsMeta = useSelector(selectManufacturerModelsMeta);
  const hydraulicTypes = useSelector(selectHydraulicWallList);
  const hasMoreManufacturers =
    !manufacturersLoading &&
    manufacturersMeta.currentPage < manufacturersMeta.totalPages;
  const hasMoreManufacturerModels =
    !manufacturerModelsLoading &&
    manufacturerModelsMeta.currentPage < manufacturerModelsMeta.totalPages;

  useEffect(() => {
    dispatch(manufacturerActions.getManufacturersList());
    dispatch(manufacturerModelActions.getManufacturerModelsList());
    dispatch(hydraulicWallActions.getHydraulicWallList());
  }, [dispatch]);

  const onMenuScroll =
    (hasMore: boolean, loadNextPage: () => void) =>
    (event: UIEvent<HTMLElement>) => {
      if (!hasMore) return;

      const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
      if (scrollHeight - (scrollTop + clientHeight) <= 2) {
        loadNextPage();
      }
    };

  const onManufacturerMenuScroll = onMenuScroll(hasMoreManufacturers, () =>
    dispatch(manufacturerActions.getNextPageItems())
  );
  const onManufacturerModelMenuScroll = onMenuScroll(
    hasMoreManufacturerModels,
    () => dispatch(manufacturerModelActions.getNextPageItems())
  );

  return {
    manufacturerOptions: toOptions(
      manufacturers.map((row) => row.menufecturerName)
    ),
    manufacturerModelOptions: toOptions(
      manufacturerModels.map((row) => row.modelDesc)
    ),
    hydraulicOptions: toOptions(
      hydraulicTypes.map((row) => row.hydraulicTypeName)
    ),
    onManufacturerMenuScroll,
    onManufacturerModelMenuScroll,
  };
};
